// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"a38085a3","1029":"ce117d17","1573":"e4aa2150","2448":"90bf704c","2835":"a7b2c545","5653":"fef1f85b","8502":"816474c6","9832":"c5f0d43c"}[chunkId] + ".chunk.css";
};